var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpertSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#CA2B2B",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.364 17.636L26.828 21.172M30.364 17.636C28.6762 15.9482 26.3869 15 24 15C21.6131 15 19.3238 15.9482 17.636 17.636M30.364 17.636C32.0518 19.3238 33 21.6131 33 24C33 25.1819 32.7672 26.3522 32.3149 27.4442C31.8626 28.5361 31.1997 29.5283 30.364 30.364M26.828 21.172C26.0779 20.4219 25.0609 20 24 20C22.9391 20 21.9221 20.4219 21.172 21.172M26.828 21.172C27.5781 21.9221 28 22.9391 28 24C28 25.0609 27.5781 26.0779 26.828 26.828M26.828 26.828L30.364 30.364M26.828 26.828C26.0779 27.5781 25.0609 28 24 28C22.9391 28 21.9221 27.5781 21.172 26.828M30.364 30.364C29.5283 31.1997 28.5361 31.8626 27.4442 32.3149C26.3522 32.7672 25.1819 33 24 33C22.8181 33 21.6478 32.7672 20.5558 32.3149C19.4639 31.8626 18.4717 31.1997 17.636 30.364M21.172 21.172L17.636 17.636M21.172 21.172C20.4219 21.9221 20 22.9391 20 24C20 25.0609 20.4219 26.0779 21.172 26.828M17.636 17.636C15.9482 19.3238 15 21.6131 15 24C15 25.1819 15.2328 26.3522 15.6851 27.4442C16.1374 28.5361 16.8003 29.5283 17.636 30.364M21.172 26.828L17.636 30.364",
    stroke: "url(#paint0_linear_2174_14093)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2174_14093",
    x1: 15,
    y1: 24,
    x2: 33,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertSupport);
export default __webpack_public_path__ + "static/media/Expert Support.7fef49007b918510233390849e36398b.svg";
export { ForwardRef as ReactComponent };